import { Seller } from "../../../Models/Seller";
import { SellerMetrics } from "../../../Models/SellerMetrics";
import { SellerPlan } from "../../../Models/SellerPlan";
import { BaseAPICallsHandler } from "../BaseAPICallsHandler";
import { NetworkUtils } from "../NetworkUtils";
import { ServerConfig } from "../ServerConfig";
import { AuthAPIHandler } from "./AuthAPIHandler";


export class SellerAPIHandler {
    
    public static shared = new SellerAPIHandler()
    
    apiHandler = BaseAPICallsHandler.shared
    serverConfig = ServerConfig.shared
    networkUtils = NetworkUtils.shared

    // dependency injection here
    constructor();
    constructor(apiHandler: BaseAPICallsHandler, serverConfig: ServerConfig, networkUtils: NetworkUtils);
    public constructor(...params: any[]) {
        if(params.length >= 3) {
            this.apiHandler = params[0];
            this.serverConfig = params[1];
            this.networkUtils = params[2];
        }
    };

    public async createSeller(sellerFormData: any) {

        let createSellerUrl = this.serverConfig.sellerAPIs.createSellerAPI
        let authHeaders = this.networkUtils.addAuthHeaders({});

        try {

            let sellerResponse = await this.apiHandler.makePostRequest(authHeaders, createSellerUrl, sellerFormData);
            let sellerData = sellerResponse.data.seller;
            // This is to update the existing JWT with new JWT with updated buyer payload which includes seller Id
            (new AuthAPIHandler()).performPostLoginFlow(sellerResponse);
            let seller = new Seller(sellerData);
            return Promise.resolve(seller);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async updateSeller(dataToUpdate: any) {

        let updateSellerUrl = this.serverConfig.sellerAPIs.updateSellerAPI
        let authHeaders = this.networkUtils.addAuthHeaders({
            'Content-Type': 'multipart/form-data'
          });

        try {

            let sellerResponse = await this.apiHandler.makePutRequest(authHeaders, updateSellerUrl, dataToUpdate);
            let sellerData = sellerResponse.data.seller
            let seller = new Seller(sellerData);
            return Promise.resolve(seller);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async getSellerByAuthId(): Promise<Seller>  {
        let url = this.serverConfig.sellerAPIs.getSellerByAuthIdAPI;
        let authHeaders = this.networkUtils.addAuthHeaders({});

        try {

            let sellerResponse = await this.apiHandler.makeGetRequest(authHeaders, url);
            let sellerData = sellerResponse.data.seller
            let seller = new Seller(sellerData);
            return Promise.resolve(seller);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async getSellerById(sellerID: string): Promise<Seller>  {
        let url = this.serverConfig.sellerAPIs.getSellerByIdAPI + sellerID;

        try {
            
            let sellerResponse = await this.apiHandler.makeGetRequest({}, url);
            let sellerData = sellerResponse.data.seller
            let seller = new Seller(sellerData);
            return Promise.resolve(seller);
            
        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async getSellerMetricsById(sellerID: string): Promise<SellerMetrics>  {
        let url = this.serverConfig.sellerAPIs.sellerMetricsAPI + sellerID;
        let authHeaders = this.networkUtils.addAuthHeaders({});

        try {
            
            let sellerResponse = await this.apiHandler.makeGetRequest(authHeaders, url);
            let sellerMetricsData = sellerResponse.data.sellerMetrics
            let sellerMetrics = new SellerMetrics(sellerMetricsData);
            return Promise.resolve(sellerMetrics);
            
        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async getSellerFormData(): Promise<Seller> {
        let url = this.serverConfig.sellerAPIs.getSellerFormData
        let authHeaders = this.networkUtils.addAuthHeaders({});

        try {

            let sellerResponse = await this.apiHandler.makeGetRequest(authHeaders, url)
            let sellerData = sellerResponse.data.sellerFormData
            let seller = new Seller(sellerData);
            return Promise.resolve(seller);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async saveSellerFormData(sellerFormData: any, pageNumber: number): Promise<Seller> {
        let url = this.serverConfig.sellerAPIs.saveSellerFormData + pageNumber
        let authHeaders = this.networkUtils.addAuthHeaders({});

        try {

            let sellerResponse = await this.apiHandler.makePostRequest(authHeaders, url, sellerFormData)
            let sellerData = sellerResponse.data.sellerFormData
            let seller = new Seller(sellerData);
            return Promise.resolve(seller);
            
        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async getSellerPlanById(planId: string): Promise<SellerPlan> {
        let url = this.serverConfig.sellerAPIs.getSellerPlanByIdAPI(planId);

        try {
            let response = await this.apiHandler.makeGetRequest({}, url);
            let planData = response.data.plan;
            let plan = new SellerPlan(planData);
            return Promise.resolve(plan);
        } catch (err) {
            return Promise.reject(err);
        }
    }

}